export const ReadMore = ({
  englishContent,
  limit,
  onClick,
}: {
  englishContent: string | JSX.Element;
  limit: number;
  onClick: () => void;
}) => {
  // if (typeof englishContent === 'string' && englishContent.length <= limit) {
  //   return <div>{englishContent}</div>;
  // }
  const toShow = typeof englishContent === 'string' && englishContent.substring(0, limit) + ' ';
  return (
    <div>
      {toShow}
      <button onClick={onClick} className="text-primary lg:text-title-7 text-body-2 cursor-pointer font-bold">
        Read more....
      </button>
    </div>
  );
};

export default ReadMore;
